<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Tariff Details</ion-title>
            </ion-buttons>
            <ion-buttons slot="end">
            <ion-button class="hdrBtn" @click="addNewCPO">
              Edit
            </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <TariffDetails />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
import TariffDetails from "@/components/admin/TariffDetails.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonBackButton } from '@ionic/vue';

export default defineComponent({
  name:  'tariffDetails',
  components: {
    TariffDetails, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
      add,
      selectedTariff: null
    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    
    addNewCPO() {
      this.$router.push("addNewTariff"); 
    }
  }
})
</script>